import { render } from "./PromotionView.vue?vue&type=template&id=2e08313c"
import script from "./PromotionView.vue?vue&type=script&lang=js"
export * from "./PromotionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__